// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__oLX70","header":"PatientBlock_header__MKn5t","label":"PatientBlock_label__2JVHC","option":"PatientBlock_option__1cn2i"};